import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Loader } from "@googlemaps/js-api-loader";
import { Box } from "@mui/material";
import { mapStyles } from "./components/mapStyles";
import { useTranslation } from "react-i18next";
import { CircleDot } from "lucide-react";
import { Alert } from "@mui/lab";
import StorePin from "../../../../files/img/pins/store50.png";
import UserPin from "../../../../files/img/pins/user50.png";
import CourierPin from "../../../../files/img/pins/courier50.png";
import {defaultVariables} from "../../../../config";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../config/design/styles";
import {connect} from "trim-redux";

const SingleOrderMap = ({
                            coordinates = { lat: 41.0082, lng: 28.9784 }, // First static marker
                            vendor_coordinates = { lat: 41.0082, lng: 28.9784 }, // Second static marker
                            height = 250,
                            zoom = 11,
                            radiusKm,
                            order = null,
                            no_zoom = false,
                            setting
                        }) => {
    const mapRef = useRef(null);
    const markerRef = useRef(null);
    const markerVendorRef = useRef(null);
    const liveMarkerRef = useRef(null); // Ref for live marker
    const circleRef = useRef(null);
    const { t } = useTranslation();
    const [liveLocation, setLiveLocation] = useState(null); // Store the live location

    useEffect(() => {
        const loader = new Loader({
            apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
            libraries: ["places"],
        });

        loader.load().then(() => {
            const google = window.google;
            const map = new google.maps.Map(mapRef.current, {
                center: coordinates,
                zoom: zoom,
                disableDefaultUI: true,
                zoomControl: !no_zoom,
                styles: mapStyles,
                gestureHandling: "greedy",
            });

            // Static markers
            markerRef.current = new google.maps.Marker({
                position: coordinates,
                map: map,
                icon: UserPin,
            });

            markerVendorRef.current = new google.maps.Marker({
                position: vendor_coordinates,
                map: map,
                icon: StorePin,
            });

            if (!!order) {
                liveMarkerRef.current = new google.maps.Marker({
                    position: coordinates, // Initial position, will be updated
                    map: map,
                    icon: CourierPin,
                    visible:false
                });
            }

            if (radiusKm) {
                circleRef.current = new google.maps.Circle({
                    map: map,
                    center: coordinates,
                    radius: radiusKm * 1000,
                    fillColor: "rgba(255, 0, 0, 0.4)",
                    strokeColor: "#F0051F",
                    strokeWeight: 1,
                });
            }
        });

        if (!!order) {
            const fetchLiveLocation = async () => {
                try {
                    const loginToken = localStorage.getItem("ACT");
                    const config = {
                        headers: {
                            Accept: 'application/json',
                            Authorization: `Bearer ${loginToken}`,
                        }
                    };
                    const response = await axios.get(`${defaultVariables.url}/couriers/live-location/${order.number}`, config);
                    const { lat, lng } = response.data;
                    setLiveLocation({ lat, lng });

                    if (liveMarkerRef.current) {
                        liveMarkerRef.current.setPosition({ lat, lng });
                        liveMarkerRef.current.setVisible(true);
                    }
                } catch (error) {
                    console.error("Error fetching live location:", error);
                }
            };

            // Run once immediately
            fetchLiveLocation();

            // Set interval outside loader
            const interval = setInterval(fetchLiveLocation, setting.live_location_update * 60 * 1000);

            return () => clearInterval(interval); // Cleanup on unmount
        }
    }, [coordinates, radiusKm, order]);


    return (
        <>
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    height: `${height}px`,
                    borderRadius: 2,
                    overflow: "hidden",
                }}
            >
                <Box ref={mapRef} sx={{ width: "100%", height: "100%" }}></Box>
            </Box>
            {!!radiusKm && (
                <Alert
                    icon={<CircleDot fontSize="inherit" />}
                    severity="success"
                    style={{ marginTop: 10, paddingTop: 0, paddingBottom: 0 }}
                >
                    {t("radiusKmMeaning")}
                </Alert>
            )}
        </>
    );
};
const mapStateToProps = (state) => ({
    setting: state.setting,
    user: state.user,
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(SingleOrderMap));
